import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Project from './components/Project';
import { ProjectModel } from '@models/Models';
import { IoIosAddCircle } from "react-icons/io";
import { useNavigate } from 'react-router-dom';
import useProject from '@hooks/useProject';

const Home = () => {
    const navi = useNavigate();
    const { getAllProjects } = useProject();
    const [protects, setProjects] = useState<ProjectModel[]>([]);

    useEffect(() => {
        projetcsGetter();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const projetcsGetter = async () => {
        try {
            const projetcsResponse = await getAllProjects();

            if(!projetcsResponse.success){
                console.error('Error fetching projects:', projetcsResponse.message);
                alert(projetcsResponse.message);
                return;
            }

            setProjects(projetcsResponse.data as ProjectModel[]);
        }catch (error) {
            console.error('Error fetching projects:', error);
        }
    }
    return (
        <Container className='myCont'>
            <Row>
                <Col xs={10}>
                    <h1>Masterplattform</h1>
                    <p>Hier finden Sie alle Ihre Projekte.</p>
                </Col>
                <Col xs={2} className='d-flex justify-content-end align-items-center'>
                    <IoIosAddCircle
                        color={'#024442'}
                        size={35}
                        onClick={() => navi("/neue-projekt")}
                    />
                </Col>
            </Row>
            <Row>
                <Col xs={12}>
                    {protects.map((item, index) => (
                        <Project key={index} item={item}  />
                    ))}
                </Col>
            </Row>
        </Container>
    )
}

export default Home